import { render } from "./loadingComponent.vue?vue&type=template&id=40bbbd60"
import script from "./loadingComponent.vue?vue&type=script&lang=js"
export * from "./loadingComponent.vue?vue&type=script&lang=js"

import "./loadingComponent.vue?vue&type=style&index=0&id=40bbbd60&lang=css"

import exportComponent from "C:\\Users\\webencusco\\projects\\admin-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__